import { useEffect, useState } from "react";
import { useWidgetTouchValue } from "../../../shared/client/states/widgetTouch.state";

export const useSlide = (slideLength: number) => {
    const [currentIdx, setCurrentIdx] = useState(1);
    const [touchStartY, setTouchStartY] = useState<number | null>(null);
    const [touchEndY, setTouchEndY] = useState<number | null>(null);
    const widgetTouchState = useWidgetTouchValue();
    const nextSlide = () => {
        if (slideLength > currentIdx) setCurrentIdx((prev) => prev + 1);
    };

    const prevSlide = () => {
        if (currentIdx > 1) setCurrentIdx((prev) => prev - 1);
    };

    const goSlide = (targetIndex: number) => {
        if (targetIndex >= 1 && targetIndex <= slideLength) setCurrentIdx(targetIndex);
    };

    const handleWheel = (event: React.WheelEvent) => {
        if (event.deltaY > 0) nextSlide();
        if (event.deltaY < 0) prevSlide();
    };

    const handleTouchStart = (event: React.TouchEvent) => {
        if (!widgetTouchState) setTouchStartY(event.touches[0].clientY);
    };

    const handleTouchEnd = () => {
        if (!touchStartY || !touchEndY) return;
        const swipeDistanceY = touchStartY - touchEndY;

        if (swipeDistanceY > 75) nextSlide(); // 스와이프 아래 → 위
        if (swipeDistanceY < -75) prevSlide(); // 스와이프 위 → 아래

        setTouchStartY(null);
        setTouchEndY(null);
    };

    const handleTouchMove = (event: React.TouchEvent) => {
        if (!widgetTouchState) setTouchEndY(event.touches[0].clientY);
    };

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto";
        };
    }, []);
    return {
        currentIdx,
        nextSlide,
        prevSlide,
        goSlide,
        handleWheel,
        handleTouchStart,
        handleTouchEnd,
        handleTouchMove,
    };
};
